import { toPercentageString } from '@kvika/string-utils'

export const getAudurCompanyAccountInterestText = (interestRate: number): string => {
	return `Fyrirtækjareikningur Auðar er óverðtryggður með breytilegum vöxtum. Hann er nú ${toPercentageString(
		interestRate,
		2
	)} vexti og eru vextir greiddir út í lok árs. Vaxtakjör eru háð ákvörðun Auðar hverju sinni og taka mið af vaxtastigi á fjármálamarkaði.`
}

export const getMarketCompanyAccountInterestText = (interestRate: number): string => {
	return `Meðalvextir á sambærilegum innlánsreikningum eru ${toPercentageString(
		interestRate,
		2
	)} skv. Aurbjörgu (www.aurbjorg.is)`
}
